// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const ScissorsIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "Scissors/solid"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M5.5 2a3.5 3.5 0 1 0 1.665 6.58L8.586 10l-1.42 1.42a3.5 3.5 0 1 0 1.414 1.414l8.127-8.127a1 1 0 0 0-1.414-1.414L10 8.586l-1.42-1.42A3.5 3.5 0 0 0 5.5 2ZM4 5.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm0 9a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M12.829 11.414a1 1 0 0 0-1.415 1.414l3.879 3.88a1 1 0 0 0 1.414-1.415l-3.879-3.879Z"
}));
export default ScissorsIcon;